import { useState } from 'react'

import BackgroundShadowPage from '@components/BackgroundShadowPage'

import useAppQueryState from '@hooks/useAppQueryState'
import useFeatureFlagContext from '@hooks/useFeatureFlagContext'

import { useMinimumGuaranteedCreditLimitQuery } from '@queries/useMinimumGuaranteedCreditLimitQuery'

import ScoredTableRoute from '@routes/ScoredTableRoute/ScoredTableRoute'
import ScoredTableSkeleton from '@routes/ScoredTableRoute/components/ScoredTableSkeleton'

import GuaranteedCreditLimitIntroModal from './components/GuaranteedCreditLimitIntroModal'

const GuaranteedCreditLimitIntroRoute = () => {
    const [showScoredTable, setShowScoredTable] = useState(false)
    const { appQueryState } = useAppQueryState()

    const minimumGuaranteedCreditLimitResponse =
        useMinimumGuaranteedCreditLimitQuery({
            customerId: appQueryState.customerId,
        })

    const featureFlagContext = useFeatureFlagContext()

    if (
        minimumGuaranteedCreditLimitResponse.isLoading ||
        featureFlagContext.isLoading
    ) {
        return (
            <>
                <BackgroundShadowPage />
                <ScoredTableSkeleton />
            </>
        )
    }

    const hasGuaranteedCreditLimitData =
        minimumGuaranteedCreditLimitResponse.data !== null

    const hasCreditLimit =
        minimumGuaranteedCreditLimitResponse?.data
            ?.minimumGuaranteedCreditLimit != null

    const isDeferred =
        minimumGuaranteedCreditLimitResponse?.data?.isDeferred === true

    if (
        !showScoredTable &&
        (!hasGuaranteedCreditLimitData || (!hasCreditLimit && !isDeferred))
    ) {
        return (
            <>
                <ScoredTableSkeleton />
                <GuaranteedCreditLimitIntroModal
                    onCloseModal={() => setShowScoredTable(true)}
                />
            </>
        )
    }

    return <ScoredTableRoute />
}

export default GuaranteedCreditLimitIntroRoute
